import { MakeCall } from 'ha/services/apiV2/createMakeCall';

export default (makeCall: MakeCall) => (
  paymentPlanToken: string,
): Promise<{ status: number }> =>
  makeCall('POST', '/api/v1/plans/accept', {
    data: { token: paymentPlanToken },
  });
